import { Attributes, Misc, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export default class RollbackAllocationsCommand extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public issuerInvestmentId: number = 0;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public fromDate: Date | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<RollbackAllocationsCommand>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Rollback Allocations Command";
    }
}